export default __webpack_public_path__ + "static/media/004-B-allocations.d3da6f3e.svg";